let baseUrl = '';
console.log(process.env.NODE_ENV, '===环境');
let httpUrl = '';
let pcHttpUrl = '';
if (process.env.NODE_ENV === 'production') {
	baseUrl = 'https://service.gyqxmall.com';
	httpUrl = 'https://m.gyqxmall.com';
	pcHttpUrl = 'https://www.gyqxmall.com';
} else if (process.env.NODE_ENV === 'testing') {
	baseUrl = 'https://service-slb.cmic.com.cn';
	httpUrl = 'https://beta-m.cmic.com.cn';
	pcHttpUrl = 'https://www-beta.cmic.com.cn';
} else if (process.env.NODE_ENV === 'vmware') {
	baseUrl = 'http://10.17.86.77:8769';
	httpUrl = 'http://10.17.86.77:8000/';
	pcHttpUrl = 'http://10.17.86.77:8000/';
} else if (process.env.NODE_ENV === 'alpha') {
	baseUrl = 'https://service-slb.cmic.com.cn';
	httpUrl = 'https://beta-m.cmic.com.cn';
	pcHttpUrl = 'https://www-alpha.cmic.com.cn';
} else if (process.env.NODE_ENV === 'uat') {
	baseUrl = 'https://service-uat.gyqxmall.com';
	httpUrl = 'https://m-uat-seo.gyqxmall.com';
	pcHttpUrl = 'https://www-uat.gyqxmall.com';
} else if (process.env.NODE_ENV === 'vmware') {
	baseUrl = 'http://10.17.86.77:8769';
	httpUrl = 'https://beta-m.cmic.com.cn';
} else if (process.env.NODE_ENV === 'development') {
	// 此乃Json 测试使用，请无视
	baseUrl = 'https://service-slb.cmic.com.cn';
	// baseUrl = 'http://10.17.86.252:8769';   // 黄鑫
	httpUrl = 'https://beta-m.cmic.com.cn';
}
export default {
	baseUrl,
	httpUrl,
	pcHttpUrl,
};
